/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as PrivateRouteRouteImport } from './routes/_private/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicTycRouteImport } from './routes/_public/tyc'
import { Route as PublicTenantSelectionRouteImport } from './routes/_public/tenant-selection'
import { Route as PublicPrivacyPolicyRouteImport } from './routes/_public/privacy-policy'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicHomeRouteImport } from './routes/_public/home'
import { Route as PublicCallbackRouteImport } from './routes/_public/callback'
import { Route as PrivateUserRouteImport } from './routes/_private/user'
import { Route as PrivateSettingsRouteImport } from './routes/_private/settings'
import { Route as PrivateFeedbackRouteImport } from './routes/_private/feedback'
import { Route as PrivateCredentialCallbackRouteImport } from './routes/_private/credential-callback'
import { Route as PrivateChatRouteImport } from './routes/_private/chat'
import { Route as PrivateBillingRouteImport } from './routes/_private/billing'
import { Route as PrivateAdminsettingsRouteImport } from './routes/_private/adminsettings'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRouteRoute = PrivateRouteRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicTycRoute = PublicTycRouteImport.update({
  id: '/tyc',
  path: '/tyc',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicTenantSelectionRoute = PublicTenantSelectionRouteImport.update({
  id: '/tenant-selection',
  path: '/tenant-selection',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicPrivacyPolicyRoute = PublicPrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicHomeRoute = PublicHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicCallbackRoute = PublicCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PrivateUserRoute = PrivateUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateSettingsRoute = PrivateSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateFeedbackRoute = PrivateFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateCredentialCallbackRoute =
  PrivateCredentialCallbackRouteImport.update({
    id: '/credential-callback',
    path: '/credential-callback',
    getParentRoute: () => PrivateRouteRoute,
  } as any)
const PrivateChatRoute = PrivateChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateBillingRoute = PrivateBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => PrivateRouteRoute,
} as any)
const PrivateAdminsettingsRoute = PrivateAdminsettingsRouteImport.update({
  id: '/adminsettings',
  path: '/adminsettings',
  getParentRoute: () => PrivateRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/adminsettings': typeof PrivateAdminsettingsRoute
  '/billing': typeof PrivateBillingRoute
  '/chat': typeof PrivateChatRoute
  '/credential-callback': typeof PrivateCredentialCallbackRoute
  '/feedback': typeof PrivateFeedbackRoute
  '/settings': typeof PrivateSettingsRoute
  '/user': typeof PrivateUserRoute
  '/callback': typeof PublicCallbackRoute
  '/home': typeof PublicHomeRoute
  '/login': typeof PublicLoginRoute
  '/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/tenant-selection': typeof PublicTenantSelectionRoute
  '/tyc': typeof PublicTycRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/adminsettings': typeof PrivateAdminsettingsRoute
  '/billing': typeof PrivateBillingRoute
  '/chat': typeof PrivateChatRoute
  '/credential-callback': typeof PrivateCredentialCallbackRoute
  '/feedback': typeof PrivateFeedbackRoute
  '/settings': typeof PrivateSettingsRoute
  '/user': typeof PrivateUserRoute
  '/callback': typeof PublicCallbackRoute
  '/home': typeof PublicHomeRoute
  '/login': typeof PublicLoginRoute
  '/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/tenant-selection': typeof PublicTenantSelectionRoute
  '/tyc': typeof PublicTycRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_private': typeof PrivateRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_private/adminsettings': typeof PrivateAdminsettingsRoute
  '/_private/billing': typeof PrivateBillingRoute
  '/_private/chat': typeof PrivateChatRoute
  '/_private/credential-callback': typeof PrivateCredentialCallbackRoute
  '/_private/feedback': typeof PrivateFeedbackRoute
  '/_private/settings': typeof PrivateSettingsRoute
  '/_private/user': typeof PrivateUserRoute
  '/_public/callback': typeof PublicCallbackRoute
  '/_public/home': typeof PublicHomeRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/privacy-policy': typeof PublicPrivacyPolicyRoute
  '/_public/tenant-selection': typeof PublicTenantSelectionRoute
  '/_public/tyc': typeof PublicTycRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/adminsettings'
    | '/billing'
    | '/chat'
    | '/credential-callback'
    | '/feedback'
    | '/settings'
    | '/user'
    | '/callback'
    | '/home'
    | '/login'
    | '/privacy-policy'
    | '/tenant-selection'
    | '/tyc'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/adminsettings'
    | '/billing'
    | '/chat'
    | '/credential-callback'
    | '/feedback'
    | '/settings'
    | '/user'
    | '/callback'
    | '/home'
    | '/login'
    | '/privacy-policy'
    | '/tenant-selection'
    | '/tyc'
  id:
    | '__root__'
    | '/'
    | '/_private'
    | '/_public'
    | '/_private/adminsettings'
    | '/_private/billing'
    | '/_private/chat'
    | '/_private/credential-callback'
    | '/_private/feedback'
    | '/_private/settings'
    | '/_private/user'
    | '/_public/callback'
    | '/_public/home'
    | '/_public/login'
    | '/_public/privacy-policy'
    | '/_public/tenant-selection'
    | '/_public/tyc'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRouteRoute: typeof PrivateRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/tyc': {
      id: '/_public/tyc'
      path: '/tyc'
      fullPath: '/tyc'
      preLoaderRoute: typeof PublicTycRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/tenant-selection': {
      id: '/_public/tenant-selection'
      path: '/tenant-selection'
      fullPath: '/tenant-selection'
      preLoaderRoute: typeof PublicTenantSelectionRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/privacy-policy': {
      id: '/_public/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PublicPrivacyPolicyRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/home': {
      id: '/_public/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof PublicHomeRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/callback': {
      id: '/_public/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof PublicCallbackRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_private/user': {
      id: '/_private/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof PrivateUserRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/settings': {
      id: '/_private/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PrivateSettingsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/feedback': {
      id: '/_private/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof PrivateFeedbackRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/credential-callback': {
      id: '/_private/credential-callback'
      path: '/credential-callback'
      fullPath: '/credential-callback'
      preLoaderRoute: typeof PrivateCredentialCallbackRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/chat': {
      id: '/_private/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof PrivateChatRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/billing': {
      id: '/_private/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof PrivateBillingRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
    '/_private/adminsettings': {
      id: '/_private/adminsettings'
      path: '/adminsettings'
      fullPath: '/adminsettings'
      preLoaderRoute: typeof PrivateAdminsettingsRouteImport
      parentRoute: typeof PrivateRouteRoute
    }
  }
}

interface PrivateRouteRouteChildren {
  PrivateAdminsettingsRoute: typeof PrivateAdminsettingsRoute
  PrivateBillingRoute: typeof PrivateBillingRoute
  PrivateChatRoute: typeof PrivateChatRoute
  PrivateCredentialCallbackRoute: typeof PrivateCredentialCallbackRoute
  PrivateFeedbackRoute: typeof PrivateFeedbackRoute
  PrivateSettingsRoute: typeof PrivateSettingsRoute
  PrivateUserRoute: typeof PrivateUserRoute
}

const PrivateRouteRouteChildren: PrivateRouteRouteChildren = {
  PrivateAdminsettingsRoute: PrivateAdminsettingsRoute,
  PrivateBillingRoute: PrivateBillingRoute,
  PrivateChatRoute: PrivateChatRoute,
  PrivateCredentialCallbackRoute: PrivateCredentialCallbackRoute,
  PrivateFeedbackRoute: PrivateFeedbackRoute,
  PrivateSettingsRoute: PrivateSettingsRoute,
  PrivateUserRoute: PrivateUserRoute,
}

const PrivateRouteRouteWithChildren = PrivateRouteRoute._addFileChildren(
  PrivateRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicCallbackRoute: typeof PublicCallbackRoute
  PublicHomeRoute: typeof PublicHomeRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicPrivacyPolicyRoute: typeof PublicPrivacyPolicyRoute
  PublicTenantSelectionRoute: typeof PublicTenantSelectionRoute
  PublicTycRoute: typeof PublicTycRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicCallbackRoute: PublicCallbackRoute,
  PublicHomeRoute: PublicHomeRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicPrivacyPolicyRoute: PublicPrivacyPolicyRoute,
  PublicTenantSelectionRoute: PublicTenantSelectionRoute,
  PublicTycRoute: PublicTycRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRouteRoute: PrivateRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
